module.exports = __webpack_public_path__ + "static/media/logomin.5c947b40.svg";